import React from "react";
import Header from './Header';
import Footer from './Footer';
export default function Layout({children}) {
  return (
    <>
      <Header />
      <div
        className="container-fluid min-vh-100"
        style={{
          backgroundImage: "url(assets/img/degradado.png)",
          backgroundSize: "cover",
          backgroundRepeat: "no-repeat",
        }}
      >
        <div className="container">
          <div className="row justify-content-md-center">
            <div
              id="login-access"
              className="col-lg-6 align-self-center pt-5 px-2 my-5"
              data-aos="fade-up"
            >
              <div className="float-start-50 px-5 flex justify-content-center">
                {children}
              </div>
            </div>
          </div>
        </div>
      </div>
      <Footer />
    </>
  );
}
